export const USER_IMPORT_CSV = `You can upload a CSV with your users or just paste file content into the text area.`;
